import EditRecurringOrder from './EditRecurringOrder'

export default EditRecurringOrder



// WEBPACK FOOTER //
// ./src/components/RecurringOrders/Edit/index.js